/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_ecocheck.js                                                                                */
/**********************************************************************************************************************/
/* Controller.FormBased */

/**
 * @class this.Controller.FormBased
 */

HafasWebapp.prototype.Controller.FormBased = {
  /**
   * determins whether the form based version is in mobile view
   *
   * @method isMobileView
   * @returns {Boolean}
   */
  isMobileView: function(){
    return Hafas('#' + this.webappWrap,false).hasClassName('mq-small');
  },
  /**
   * updates config switches if necessary to modify behaviour for mobile and desktop
   *
   * @method updateConfigOnResize
   */
  updateConfigOnResize: function(){
    this.isMobileView = this.Controller.FormBased.isMobileView.bind(this)();

    // Update Pan Cake / Tab Navigation Menu Icon
    this.Controller.FormBased.updateTabNavigationIcon.bind(this)();

    // Update Config Switches
    this.Controller.FormBased.updateConfigSwitches.bind(this)();
  },
  /**
   * updates the tab navigation menu icon (a.k.a. pancake menu icon), for mobile view it needs to be shown on blue background,
   * in desktop view on white background. Therefore an icon switch is needed
   *
   * @method updateTabNavigationIcon
   */
  updateTabNavigationIcon: function(){
    var tabNavigationMenuIcon = Hafas('#HFS_FlyInMenuContainer_Tab i', false);
    if(this.isMobileView) {
      tabNavigationMenuIcon.className = 'haf_menu_bar_inv';
    }else{
      tabNavigationMenuIcon.className = 'haf_menu_bar';
    }
  },
  /**
   * can be used to adapt different behaviour for formbased mode (mobile / desktop)
   *
   * @method updateConfigSwitches
   */
  updateConfigSwitches: function(){
      // Future changes to config switches can be added here
  }
};


